import { MMButton } from '@components'
import { useCreateExpenseRequest } from '@hooks'
import cn from '@integrations/classnames'
import toast from '@integrations/notifications'
import { useContext, useState } from '@integrations/react'
import { useNavigate } from '@integrations/routing'
import { paths } from 'mmfintech-backend-api'
import { GlobalContext, isValidArray, tr } from 'mmfintech-commons'
import type { UseFormValuesOutput } from 'mmfintech-commons/types'
import { ErrorDisplay, Input } from 'mmfintech-portal-commons'
import { RequestModalSurface, RequestModalTitle } from '../RequestModalSurface'
import styles from './CreateExpenseRequestModal.module.scss'

interface Props {
  formValues: UseFormValuesOutput
}

function CreateExpenseRequestModal({ formValues }: Props) {
  const { modalHide } = useContext(GlobalContext)
  const { handleSubmit, expenseRequestsError } = useCreateExpenseRequest(formValues)
  const [text, setText] = useState('')
  const navigate = useNavigate()

  function onSuccess() {
    modalHide()
    toast.success(tr('FRONTEND.EXPENSE_MANAGEMENT.CREATE_REQUESTS.SUCCESS_TOAST', 'Request successfully accepted'))
    navigate(paths.banking.expenses())
  }

  return (
    <RequestModalSurface className={cn(styles['expense-request-modal-wrapper'], 'expense-request-modal-wrapper')}>
      <RequestModalTitle as='h3'>
        {tr('FRONTEND.EXPENSE_MANAGEMENT.CREATE_REQUESTS.TITLE', 'You have reached your monthly limit')}
      </RequestModalTitle>

      <p>
        {tr(
          'FRONTEND.EXPENSE_MANAGEMENT.CREATE_REQUESTS.CONTENT',
          'You can submit an expense request and after approval is received the transaction will be automatically initiated.'
        )}
      </p>

      <Input
        type='textarea'
        className={cn('description-input')}
        label={tr('FRONTEND.EXPENSE_MANAGEMENT.CREATE_REQUESTS.DESCRIPTION', 'Description')}
        value={text}
        name='description'
        onChange={(_: string, value: string) => setText(value)}
        rows={5}
      />

      <ErrorDisplay
        error={
          expenseRequestsError && 'cause' in expenseRequestsError
            ? isValidArray(expenseRequestsError?.cause)
              ? expenseRequestsError?.cause?.map((errCause: any) => errCause?.cause)
              : expenseRequestsError
            : null
        }
      />

      <MMButton
        variant='primary'
        caption={tr('FRONTEND.EXPENSE_MANAGEMENT.CREATE_REQUESTS.REQUEST_BUTTON', 'Request')}
        onClick={() => {
          handleSubmit(text, onSuccess)
        }}
        fullWidth
      />
      <MMButton variant='secondary' caption={tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')} onClick={modalHide} fullWidth />
    </RequestModalSurface>
  )
}

export default CreateExpenseRequestModal
